import { Flex, Heading } from '@chakra-ui/react';
import { FC, useState } from 'react';

import { ChatChannel } from '@/components/ui/shared/chat/ChatPopup/components/ChatChannel';
import { ChatChannelList } from '@/components/ui/shared/chat/ChatPopup/components/ChatChannelList';
import { ChatSwitcher } from '@/components/ui/shared/chat/ChatPopup/components/ChatSwitcher';
import { ChatSwitchTabs } from '@/components/ui/shared/chat/ChatPopup/components/types';
import { UserList } from '@/components/ui/shared/chat/ChatPopup/components/UserList';
import { ThinProfile } from '@/resources/ThinProfile';

export const ChatPopup: FC = () => {
  const [profileSelected, setProfileSelected] = useState<ThinProfile | null>(null);
  const [tabSelected, setTabSelected] = useState<ChatSwitchTabs>(ChatSwitchTabs.PEOPLE);

  return (
    <Flex h="full">
      {profileSelected && <ChatChannel setProfileSelected={setProfileSelected} profile={profileSelected} />}
      {!profileSelected && (
        <Flex h="full" w="full" px={{ base: 8, md: 5 }} py={{ base: 6, md: 6 }} flexDirection="column">
          <Heading mb={4} fontSize="2xl">
            {tabSelected === ChatSwitchTabs.PEOPLE ? 'People' : 'Messages'}
          </Heading>
          <ChatSwitcher selected={tabSelected} setSelected={setTabSelected} />
          {tabSelected === ChatSwitchTabs.PEOPLE && <UserList setProfileSelected={setProfileSelected} />}
          {tabSelected === ChatSwitchTabs.MESSAGES && <ChatChannelList setProfileSelected={setProfileSelected} />}
        </Flex>
      )}
    </Flex>
  );
};
